<template>
	<div>
		<el-row :gutter="10">
			<!-- 左边 -->
			<el-col :xs="0" :sm="15" :md="15" :lg="15" :xl="15" :offset="2">
			  <div class="grid-content left">
				  <div class="position">
					<el-breadcrumb separator-class="el-icon-d-arrow-right">
					  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  <el-breadcrumb-item>{{breadcrumb(id)}}</el-breadcrumb-item>
					</el-breadcrumb>  
				  </div>
				  <div class="contentList">
					  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						    <el-table
						      :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
						      :border="false"
							  :show-header="false"
						      style="width: 100%">
						      <el-table-column
								header-align="center"
						        prop="title"
						        label="标题">
								<template slot-scope="props">
									<el-link type="primary" @click="handle(props.row.Id)" :underline="false">{{props.row.title}}</el-link>
								</template>
						      </el-table-column>
						      <el-table-column
								align="center"
						        prop="starttime"
						        label="发布日期"
								width="110">
								<template slot-scope="props">
									{{$utils.timestampToTimes(props.row.createtime*1000)}}
								</template>
						      </el-table-column>
						    </el-table>
							<div class="pagination">
								<el-pagination
									:background="true"
								  :pager-count="pagerCount"
								  :page-size = "pageSize"
								  :page-sizes="[5,10,20]"
								  :current-page = "currentPage"
								  @current-change="currentChange"
								  @size-change="handleSizeChange"
								  prev-text ="上一页"
								  next-text = "下一页"
								  layout="prev, pager, next"
								  :total="total">
								</el-pagination>
							</div>
					</el-col>
				  </div>
			  </div>
			</el-col>
			<!-- 右边 -->
			<el-col :xs="0" :sm="5" :md="5" :lg="5" :xl="5">
				<div class="grid-content first">
					<el-carousel :interval="6000" arrow="never">
						<el-carousel-item v-for="item in bannerTop" :key="item.Id">
							<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="grid-content second">
					<div class="listHeader">
						采购中心
					</div>
					<el-card class="box-card">
					  <div v-for="o in caigoulist.slice(0,4)" :key="o.Id" class="text item" @click="handle(o.Id)">
						{{o.title.substring(0,18)}}
					  </div>
					</el-card>  
				</div>
				<div class="grid-content third">
					<el-carousel :interval="5000" arrow="never">
						<el-carousel-item v-for="item in bannerMiddle" :key="item.Id">
							<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="grid-content four">
					<div class="listHeader">
						散单需求
					</div>
					<el-card class="box-card">
					  <div v-for="o in sandanlist.slice(0,4)" :key="o.Id" class="text item" @click="handle(o.Id)">
						{{o.title.substring(0,18)}}
					  </div>
					</el-card>    
				</div>
			</el-col>
		</el-row>
		<!-- 手机端 -->
		<el-row style="margin-bottom: 30px;">
			<!-- 左边 -->
			<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
			  <div class="grid-content left">
				  <div class="position">
					<el-breadcrumb separator-class="el-icon-d-arrow-right">
					  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  <el-breadcrumb-item>{{breadcrumb(id)}}</el-breadcrumb-item>
					</el-breadcrumb>  
				  </div>
				  <div class="contentList">
					  <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
						    <el-table
						      :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
						      :border="false"
							  :show-header="false"
						      style="width: 100%">
						      <el-table-column
								header-align="center"
						        prop="title"
						        label="标题">
								<template slot-scope="props">
									<el-link type="primary" @click="handle(props.row.Id)" :underline="false">{{props.row.title}}</el-link>
								</template>
						      </el-table-column>
						      <!-- <el-table-column
								align="center"
						        prop="starttime"
						        label="发布日期">
								<template slot-scope="props">
									{{$utils.timestampToTimes(props.row.createtime*1000)}}
								</template>
						      </el-table-column> -->
						    </el-table>
							<div class="pagination">
								<el-pagination
									:background="true"
								  :pager-count="pagerCount"
								  :page-size = "pageSize"
								  :page-sizes="[5,10,20]"
								  :current-page = "currentPage"
								  @current-change="currentChange"
								  @size-change="handleSizeChange"
								  prev-text ="上一页"
								  next-text = "下一页"
								  layout="prev, pager, next"
								  :total="total">
								</el-pagination>
							</div>
					</el-col>
				  </div>
			  </div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	name:'newslist',
	metaInfo() {
	  return {
		title: this.metaName,
		meta: [
		  { charset: "utf-8" },
		  { name: "keywords", content: this.metaKeywords },
		  { name: "description", content: this.metaDecs },
		],
	  };
	},
  data() {
    return {
		id:0,
		bannerTop:[],
		bannerMiddle:[],
		domain:this.$utils.httpUrl,
		total:0,
		currentPage:1,
		pageSize:20,
		pagesize:20,
		pagerCount:5,
		metaName: "",
		title:"",
		metaKeywords: "",
		metaDecs: "",
		caigoulist:[],
		ztbcslist:[],
		wlzxlist:[],
		sandanlist:[],
		loading: false,
		post: null,
		error: null,
		keywords:'',
		value: '',
		tableData: []
    }
  },
  mounted() {
  	// console.log('sss',this.$route)
	this.id = this.$route.params.id
  },
  watch: {
      $route() {
        if (this.$route.params.id != null) {
          this.id = this.$route.params.id
  		  if(this.id == 3){
  			  this.tableData = this.caigoulist
  			  this.metaName = '采购中心 - ' + this.title
  		  }else if(this.id == 5){
  			  this.tableData = this.ztbcslist
  			  this.metaName = '招投标常识 - ' + this.title
  		  }else if(this.id == 6){
  			  this.tableData = this.wlzxlist
  			  this.metaName = '物流常识 - ' + this.title
  		  }
        }
      },
    },
  created() {
	this.getBanners()  
	this.getCaigoulist()
	this.getZhaobiao()
	this.$axios({
		url:this.$utils.httpApi + 'index/webconfig'
	}).then(res=>{
		this.title = res.data.data.webtitle
		if(this.id == 3){
		  this.metaName = '采购中心 - ' + this.title
		}else if(this.id == 5){
		  this.metaName = '招投标常识 - ' + this.title
		}else if(this.id == 6){
		  this.metaName = '物流常识 - ' + this.title
		}
		this.metaDecs = res.data.data.webdescription
		this.metaKeywords = res.data.data.webkeywords
	})
    // watch 路由的参数，以便再次获取数据
    // this.$watch(
    //   () => this.$route.params,
    //   () => {
    //     this.fetchData()
    //   },
    //   // 组件创建完后获取数据，
    //   // 此时 data 已经被 observed 了
    //   { immediate: true }
    // )
  },
  methods: {
	  breadcrumb(id){
	  	if(id == 3){
	  		return '采购中心'
	  	}else if(id == 5){
	  		return '招投标常识'
	  	}else if(id == 6){
	  		return '物流常识'
	  	}
	  },
	  getZhaobiao(){
	  	this.$axios({
	  		url:this.$utils.httpApi + 'index/getZhaobiao'
	  	}).then(res=>{
	  		res.data.data.forEach(resp=>{
	  			if(resp.typelist == 1 && resp.status > 2){
	  				this.sandanlist.push(resp)

	  			}
	  		})
	  	})   
	  },
	  getBanners(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getBanner'
		}).then(res=>{
			res.data.data.forEach(resp=>{
				if(resp.type == 4){
					this.bannerTop.push(resp)
				}else if(resp.type == 5){
					this.bannerMiddle.push(resp)
				}
			})
		}) 
	  },
	  getCaigoulist(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getCaigou'
		}).then(res=>{
			res.data.data.forEach(resp=>{
				if(resp.typelist == 0){
					this.caigoulist.push(resp)
					if(this.id == 3){
						this.tableData = this.caigoulist
						this.total = this.tableData.length
					}
				}else if(resp.typelist == 1){
					this.ztbcslist.push(resp)
					if(this.id == 5){
						this.tableData = this.ztbcslist
						this.total = this.tableData.length	
					}
				}else if(resp.typelist == 2){
					this.wlzxlist.push(resp)
					if(this.id == 6){
						this.tableData = this.wlzxlist
						this.total = this.tableData.length	
					}
				}
			})
		})   
	  },
	  handleSizeChange(pageSize){
	  	console.log('handleSizeChange',pageSize)
	  	 this.pagesize = pageSize
	  },
	  currentChange(pageNum){
	  	console.log('currentChange',pageNum)
	  	this.currentPage = pageNum; 
	  },
    // fetchData() {
    //   this.error = this.post = null
    //   this.loading = true
    //   // replace `getPost` with your data fetching util / API wrapper
    //   getPost(this.$route.params.id, (err, post) => {
    //     this.loading = false
    //     if (err) {
    //       this.error = err.toString()
    //     } else {
    //       this.post = post
    //     }
    //   })
    // },
	handle(id){
		// this.$router.push('/newsdetails/id/'+id)
		const url = '/newsdetails/id/'+id
		window.open(url, '_blank')
	}
  },
}
</script>

<style scoped>
	.text{
		cursor: pointer;
		color:#409EFF;
	}
	.el-col {
		border-radius: 4px;
	}
	.bg-purple-dark {
		background: #99a9bf;
	}
	.bg-purple {
		background: #d3dce6;
	}
	.bg-purple-light {
		background: #e5e9f2;
	}
	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}
	.search{
		margin:10px auto;
	}
	.contentList{
		margin-top: 10px;
	}
	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}
	.text {
		font-size: 14px;
	}

	.item {
		padding: 18px 0;
	}

	.box-card {
		/* width: 480px; */
	}	
	.listHeader{
		background-color: #409EFF;
		width:100%;
		height:40px;
		color:#fff;
		line-height: 40px;
		text-align: center;
		font-size: 1.1rem;
		font-weight: 700;
		margin-top: 10px;
	}
	.second{
		margin-bottom: 10px;
	}
</style>